import { History as OriginalHistory } from 'history';

export type History = OriginalHistory;
